import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all Lottos
 */
export function getLotto(callback) {
  database.ref('lotto').on('value', function(snapshot) {
    if (snapshot.exists()) {
      const lotto = snapshot.val();
      callback(true, lotto, null);
    }
    else {
      callback(true, {}, null);
    }
  })
}

export function setLotto(data, callback) {
  database.ref('lotto').set(data, function(error) {
      if (error) {
          callback(false, null, error);
      } else {
          callback(true, data, null);
      }
  })
}

/**
 * Create new news
 */
export function createNewLotto (data, callback) {
    database.ref('lotto').update(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Edit news
 */
export function editLotto (id, data, callback) {
    database.ref('lotto/' + id).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Delete news
 */
export function deleteLotto(id, callback) {
    database.ref('lotto').child(id).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, id, null);
        }
    });
}
